export const convertText = (text) => {
  if (!text) {
    return "";
  }
  let result = text;
  result = result.replaceAll("\n", "<br/>");
  let links = text.match(/\[[0-9a-zа-я\s\-\"\._\/]{0,}\]\([0-9a-zа-я\s\/\:\.\-\#_]{0,}\)/gi);
  if (links?.length > 0) {
    links.forEach((element) => {
      let title = element.match(/\[[0-9a-zа-я\s\-\"\._\/]{0,}\]/i)[0].slice(1, -1);
      let href = element.match(/\([0-9a-zа-я\s\/\:\.\-\#_]{0,}\)/i)[0].slice(1, -1);
      result = result.replace(element, `<a href="${href}" target="_blank">${title}</a>`);
    });
  }
  links = text.match(/[^(](http|https):\/\/[a-zA-Z0-9.-_\/]{1,}/gi);
  if (links?.length > 0) {
    links.forEach((element) => {
      result = result.replace(element, `<a href="${element}" target="_blank">${element}</a>`);
    });
  }
  return result;
};

export const uniq = (array) => {
  return array.reduce((acc, current) => {
    current = current.trim();
    if (!acc.includes(current)) {
      acc.push(current);
    }
    return acc;
  }, []);
};

export const groupBy = (array, fieldName) => {
  let a = uniq(array.map((x) => x[fieldName]));
  let b = {};
  a.forEach((element) => {
    b[element] = array.filter((x) => x[fieldName] == element);
  });
  return b;
};
